import React from 'react';
import { motion } from 'framer-motion';

const cells = [
  'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=600&auto=format&fit=crop',
  '',
  'https://images.unsplash.com/photo-1495567720989-cebdbdd97913?q=80&w=600&auto=format&fit=crop',
  '',
  'https://images.unsplash.com/photo-1504196606672-aef5c9cefc92?q=80&w=600&auto=format&fit=crop',
  '',
];

const positions = [
  { x: 40, y: 70 },
  { x: 240, y: 70 },
  { x: 240, y: 210 },
  { x: 440, y: 210 },
  { x: 140, y: 210 },
  { x: 40, y: 70 },
];

const MoodBoardDemo: React.FC = () => {
  // Container is ~540x320 in our layout; tune cursor coords accordingly
  return (
    <div className="relative rounded-2xl p-6 bg-gradient-to-br from-pink-500 via-fuchsia-500 to-orange-400 shadow-2xl">
      <div className="flex items-center justify-between text-white/90 mb-4">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">🎨</div>
          <span className="font-medium">Mood Board</span>
        </div>
        <span className="text-sm">3 collaborators</span>
      </div>

      <div className="relative bg-white/10 rounded-xl p-4 backdrop-blur-sm">
        <div className="grid grid-cols-3 gap-4">
          {cells.map((src, i) => (
            <div key={i} className="aspect-square rounded-lg overflow-hidden bg-white/10">
              {src ? (
                <motion.img
                  src={src}
                  alt=""
                  className="w-full h-full object-cover"
                  initial={{ scale: 1.05, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 0.8, delay: i * 0.08 }}
                />
              ) : (
                <div className="w-full h-full bg-gradient-to-br from-white/10 to-white/0" />
              )}
            </div>
          ))}
        </div>

        {/* Fake cursor */}
        <motion.div
          className="pointer-events-none absolute top-0 left-0"
          style={{ width: 18, height: 26 }}
          animate={{
            x: positions.map((p) => p.x),
            y: positions.map((p) => p.y),
            scale: [1, 1, 1, 1.02, 1, 1],
          }}
          transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
        >
          {/* cursor shape */}
          <svg viewBox="0 0 24 24" width="18" height="26" className="drop-shadow">
            <path d="M3 2l16 8-6 2 2 8-4-6-8 2z" fill="#fff"/>
            <path d="M3 2l16 8-6 2 2 8-4-6-8 2z" fill="#000" opacity=".15"/>
          </svg>
        </motion.div>

        {/* Click ripple synced roughly with second/third waypoints */}
        <motion.span
          className="pointer-events-none absolute -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white/70"
          style={{ width: 12, height: 12 }}
          animate={{
            x: positions.map((p) => p.x + 6),
            y: positions.map((p) => p.y + 6),
            scale: [0.6, 1.4, 0.6, 1.4, 0.6, 1.4],
            opacity: [0, 0.9, 0, 0.9, 0, 0.9],
          }}
          transition={{ duration: 6, repeat: Infinity, ease: 'linear' }}
        />
      </div>
    </div>
  );
};

export default MoodBoardDemo;


